<template>
    <div class="kt-portlet__head-label">
        <h3 class="kt-portlet__head-title"><slot></slot></h3>
    </div>
</template>
